<template>
  <div v-if="kib == 'C'">
    <FormC
      :id="id.toString()"
      :title="title"
      :kolok-val="kolok"
      :kib-val="kib"
      :kobar-val="kobar"
      :nabar-val="nabar"
      :kode-register-barang-val="kodeRegisterBarang"
      :nilai-perolehan-val="nilaiPerolehan"
      :tahun-perolehan-val="tahunPerolehan"
      :ukuran-val="ukuran"
      :jenis-beton-val="jenisBeton"
      :alamat-val="alamat"
      :satuan-val="satuan"
      :rekon-kode-val="rekonKode"
      :rekon-tahun-val="rekonTahun"
      :kesesuaian-kode-barang-val="kesesuaianKodeBarang"
      :kib-seharusnya-val="kibSeharusnya"
      :satuan-seharusnya-val="satuanSeharusnya"
      :nama-barang-seharusnya-val="namaBarangSeharusnya"
      :kode-barang-seharusnya-val="kodeBarangSeharusnya"
      :kesesuaian-ukuran-val="kesesuaianUkuran"
      :ukuran-seharusnya-val="ukuranSeharusnya"
      :nama-spesifikasi-barang-val="namaSpesifikasiBarang"
      :cara-perolehan-penerimaan-val="caraPerolehanPenerimaan"
      :is-bertingkat-val="isBertingkat"
      :bertingkat-seharusnya-val="bertingkatSeharusnya"
      :jumlah-seluruh-lantai-val="jumlahSeluruhLantai"
      :is-lantai-digunakan-val="isLantaiDigunakan"
      :jumlah-lantai-tidak-digunakan-val="jumlahLantaiTidakDigunakan"
      :jumlah-lantai-digunakan-val="jumlahLantaiDigunakan"
      :kesesuaian-bahan-val="kesesuaianBahan"
      :bahan-seharusnya-val="bahanSeharusnya"
      :sk-penggunaan-val="skPenggunaan"
      :nomor-sk-penggunaan-val="nomorSkPenggunaan"
      :tahun-sk-penggunaan-val="tahunSkPenggunaan"
      :penggunaan-val="penggunaan"
      :digunakan-bersama-val="digunakanBersama"
      :digunakan-untuk-val="digunakanUntuk"
      :pd-ukpd-val="pdUkpd"
      :pemanfaat-val="pemanfaat"
      :gedung-bangunan-tanah-milik-val="gedungBangunanTanahMilik"
      :is-gedung-bangunan-tanah-milik-tercatat-val="
        isGedungBangunanTanahMilikTercatat
      "
      :gedung-bangunan-tanah-milik-pd-ukpd-val="gedungBangunanTanahMilikPdUkpd"
      :gedung-bangunan-tanah-milik-kobar-val="gedungBangunanTanahMilikKobar"
      :gedung-bangunan-tanah-milik-register-val="gedungBangunanTanahMilikRegister"
      :gedung-bangunan-tanah-milik-keterangan-val="
        gedungBangunanTanahMilikKeterangan
      "
      :gedung-bangunan-tanah-milik-sebutkan-val="gedungBangunanTanahMilikSebutkan"
      :provinsi-val="provinsi"
      :kab-kota-val="kabKota"
      :kecamatan-val="kecamatan"
      :kelurahan-val="kelurahan"
      :jalan-val="jalan"
      :no-alamat-val="noAlamat"
      :rt-val="rt"
      :rw-val="rw"
      :kode-pos-val="kodePos"
      :is-indikasi-ganda-val="isIndikasiGanda"
      :indikasi-ganda-dengan-val="indikasiGandaDengan"
      :indikasi-ganda-sebutkan-val="indikasiGandaSebutkan"
      :indikasi-ganda-pd-ukpd-val="indikasiGandaPdUkpd"
      :indikasi-ganda-kobar-val="indikasiGandaKobar"
      :indikasi-ganda-register-val="indikasiGandaRegister"
      :indikasi-gabungan-val="indikasiGabungan"
      :indikasi-gabungan-keterangan-val="indikasiGabunganKeterangan"
      :is-atap-beton-val="isAtapBeton"
      :is-atap-beton-is-digunakan-val="isAtapBetonIsDigunakan"
      :atap-beton-digunakan-val="atapBetonDigunakan"
      :is-basement-val="isBasement"
      :is-basement-is-digunakan-val="isBasementIsDigunakan"
      :basement-digunakan-val="basementDigunakan"
      :is-halaman-utama-val="isHalamanUtama"
      :is-halaman-utama-is-digunakan-val="isHalamanUtamaIsDigunakan"
      :halaman-utama-digunakan-val="halamanUtamaDigunakan"
      :nilai-strategis-b-m-d-val="nilaiStrategisBMD"
      :memiliki-nilai-strategis-val="memilikiNilaiStrategis"
      :pengamanan-fisik-val="pengamananFisik"
      :fisik-dikuasai-val="fisikDikuasai"
      :fisik-dikuasai-sebutkan-val="fisikDikuasaiSebutkan"
      :fisik-tidak-dikuasai-sebutkan-val="fisikTidakDikuasaiSebutkan"
      :sengketa-gedung-bangunan-val="sengketaGedungBangunan"
      :ket-aset-bersejarah-val="ketAsetBersejarah"
      :status-persetujuan-val="statusPersetujuan"
      :catatan-val="catatan"
      :is-show-ubah-val="isShowUbah"
      :is-show-info="isShowInfo"
    />
  </div>
  <div v-else-if="kib == 'A'">
    <FormA />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import FormC from './form/FormC.vue'
import FormA from './form/FormA.vue'
import validasiKeberadaan from '@/composables/validasiKeberadaan'
import master from '@/composables/master'
import { intThousand } from '@/libs/helper'

const moment = require('moment')

export default {
  setup(props, context) {
    const g = context.root

    const tahunNow = ref(moment().format('YYYY'))

    const title = ref('KIB C - Fase Desktop')

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))
    let defaultKolok = { text: '-- Pilih Salah Satu --', value: null }
    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      defaultKolok = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
    }

    const kolok = ref('')
    const kib = ref('')
    const kobar = ref('')
    const nabar = ref('')
    const kodeRegisterBarang = ref('')
    const nilaiPerolehan = ref('')
    const tahunPerolehan = ref('')
    const ukuran = ref('')
    const jenisBeton = ref('')
    const alamat = ref('')
    const rekonKode = ref('')
    const rekonTahun = ref('')
    const satuan = ref('')

    const kesesuaianKodeBarang = ref('')
    const kibSeharusnya = ref(null)
    const namaBarangSeharusnya = ref('')
    const kodeBarangSeharusnya = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const satuanSeharusnya = ref('')
    const kesesuaianUkuran = ref('')
    const ukuranSeharusnya = ref('')
    const namaSpesifikasiBarang = ref('')
    const caraPerolehanPenerimaan = ref(null)
    const isBertingkat = ref('')
    const bertingkatSeharusnya = ref('')
    const jumlahSeluruhLantai = ref('')
    const isLantaiDigunakan = ref('')
    const jumlahLantaiTidakDigunakan = ref('')
    const jumlahLantaiDigunakan = ref('')
    const kesesuaianBahan = ref('')
    const bahanSeharusnya = ref(null)
    const skPenggunaan = ref('')
    const nomorSkPenggunaan = ref('')
    const tahunSkPenggunaan = ref('')
    const penggunaan = ref(null)
    const digunakanBersama = ref([])
    const pdUkpd = ref([
      {
        value: { text: '-- Pilih Salah Satu --', value: null },
      },
    ])
    const digunakanUntuk = ref([
      {
        value: '',
      },
    ])
    const pemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    const gedungBangunanTanahMilik = ref(null)
    const isGedungBangunanTanahMilikTercatat = ref(null)
    const gedungBangunanTanahMilikPdUkpd = ref(defaultKolok)
    const gedungBangunanTanahMilikKobar = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const gedungBangunanTanahMilikRegister = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const gedungBangunanTanahMilikKeterangan = ref('')
    const gedungBangunanTanahMilikSebutkan = ref('')
    const provinsi = ref(null)
    const kabKota = ref(null)
    const kecamatan = ref(null)
    const kelurahan = ref(null)
    const jalan = ref('')
    const noAlamat = ref('')
    const rt = ref('')
    const rw = ref('')
    const kodePos = ref('')
    const isIndikasiGanda = ref('')
    const indikasiGandaDengan = ref(null)
    const indikasiGandaSebutkan = ref('')
    const indikasiGandaPdUkpd = ref(defaultKolok)
    const indikasiGandaKobar = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const indikasiGandaRegister = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const indikasiGabungan = ref(null)
    const indikasiGabunganKeterangan = ref(null)
    const isAtapBeton = ref(null)
    const isAtapBetonIsDigunakan = ref(null)
    const atapBetonDigunakan = ref('')
    const isBasement = ref(null)
    const isBasementIsDigunakan = ref(null)
    const basementDigunakan = ref('')
    const isHalamanUtama = ref(null)
    const isHalamanUtamaIsDigunakan = ref(null)
    const halamanUtamaDigunakan = ref('')
    const nilaiStrategisBMD = ref(null)
    const memilikiNilaiStrategis = ref([])
    const pengamananFisik = ref(null)
    const fisikDikuasai = ref(null)
    const fisikDikuasaiSebutkan = ref('')
    const fisikTidakDikuasaiSebutkan = ref(null)
    const sengketaGedungBangunan = ref(null)
    const ketAsetBersejarah = ref(null)

    const catatan = ref('')
    const statusPersetujuan = ref(null)

    const dataPdUkpd = ref([])
    const dataGedungBangunanTanahMilikKobar = ref([])
    const dataGedungBangunanTanahMilikRegister = ref([])

    const isShowUbah = ref(true)
    const isShowInfo = ref(false)

    const getKobar = (kibKobar, kobarVal = '', kolokVal = null) => {
      const params = {
        kib: kibKobar,
        cari: kobarVal,
        kolok: kolokVal,
        length: 100000,
      }

      return master.getKobar(g, params)
    }

    const getNoReg = kibNoReg => {
      const params = {
        kib: kibNoReg,
        tahun_rekon: rekonTahun.value,
        kode_rekon: rekonKode.value,
        kolok: gedungBangunanTanahMilikPdUkpd.value.value,
        kobar:
          gedungBangunanTanahMilikKobar.value
          ?? gedungBangunanTanahMilikKobar.value
            ? gedungBangunanTanahMilikKobar.value.value
            : null,
      }
      return master.getNoReg(g, params)
    }

    const getPdUkpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunNow.value,
        cari: searchPdUpd,
      }
      const resPdUkpd = await master.getPdUpd(g, params)
      resPdUkpd.unshift({ text: '-- Pilih Salah Satu --', value: null })
      return resPdUkpd
      // dataPdUkpd.value = resPdUkpd;
      // dataIndikasiGandaPdUkpd.value = resPdUkpd;
    }

    const getData = async () => {
      const response = await validasiKeberadaan.getBmdDetail(g, {
        id: props.id,
        username: g.$cookies.get('username'),
      })
      const { data, code } = response
      if (code == 200) {
        const {
          KOLOK,
          nama_pd_ukpd_siera: namaPdUkpdSiera,
          kib: kibVal,
          kobar_108: kobar108,
          nabar_108: nabar108,
          noreg_108: noreg108,
          HARGA,
          TGLOLEH,
          UKURAN,
          BETON,
          ALAMAT,
          SATUAN,
          rekon_kode: rekonKodeVal,
          rekon_tahun: rekonTahunVal,
          status,
          di_validasi_sensus_note: diValidasiSensusNote,
          di_m_kobar: diMKobar,
          di_m_kobar_a: diMKobarA,
          di_m_ukuran: diMUkuran,
          di_m_ukuran_a: diMUkuranA,
          di_cara_perolehan: diCaraPerolehan,
          di_m_bertingkat: diMBertingkat,
          di_m_bertingkat_a: diMBertingkatA,
          di_m_lantai_tdk: diMLantaiTdk,
          di_m_lantai_tdk_use: diMLantaiTdkUse,
          di_m_lantai_tdk_not: diMLantaiTdkNot,
          di_m_beton: diMBeton,
          di_m_beton_a: diMBetonA,
          di_m_sk_penggunaan: diMSkPenggunaan,
          di_sk_penggunaan_tahun: diSkPenggunaanTahun,
          di_sk_penggunaan_no: diSkPenggunaanNo,
          di_penggunaan: diPenggunaan,
          penggunaan_pihak_lain: penggunaanPihakLain,
          penggunaan_opd: penggunaanOpd,
          di_gedung_bangunan_diatas_tanah_milik: diGedungBangunanDiatasTanahMilik,
          di_gedung_bangunan_diatas_tanah_milik_tercatat: diGedungBangunanDiatasTanahMilikTercatat,
          di_gedung_bangunan_diatas_tanah_milik_sebut: diGedungBangunanDiatasTanahMilikSebut,
          di_kd_prop: diKdProp,
          di_kd_rayon: diKdRayon,
          di_kd_kec: diKdKec,
          di_kd_kel: diKdKel,
          di_kodepos: diKodepos,
          di_jalan: diJalan,
          di_no_jalan: diNoJalan,
          di_rt: diRt,
          di_rw: diRw,
          di_indikasi_ganda: diIndikasiGanda,
          di_indikasi_ganda_dengan: diIndikasiGandaDengan,
          di_indikasi_ganda_sebutkan: diIndikasiGandaSebutkan,
          di_indikasi_ganda_opd: diIndikasiGandaOpd,
          di_indikasi_ganda_kobar: diIndikasiGandaKobar,
          di_indikasi_ganda_register: diIndikasiGandaRegister,
          di_m_kobar_kib: diMKobarKib,
          di_gedung_bangunan_diatas_tanah_milik_opd: diGedungBangunanDiatasTanahMilikOpd,
          di_gedung_bangunan_diatas_tanah_milik_kobar: diGedungBangunanDiatasTanahMilikKobar,
          di_gedung_bangunan_diatas_tanah_milik_noreg: diGedungBangunanDiatasTanahMilikNoreg,
          di_nm_spesifikasi_barang: diNmSpesifikasiBarang,
          di_indikasi_gabungan: diIndikasiGabungan,
          di_indikasi_gabungan_keterangan: diIndikasiGabunganKeterangan,
          di_pp_at_ada: diPpAtAda,
          di_pp_at_ada_digunakan: diPpAtAdaDigunakan,
          di_pp_at_ada_digunakan_oleh: diPpAtAdaDigunakanOleh,
          di_pp_bm_ada: diPpBmAda,
          di_pp_bm_ada_digunakan: diPpBmAdaDigunakan,
          di_pp_bm_ada_digunakan_oleh: diPpBmAdaDigunakanOleh,
          di_pp_ht_ada: diPpHtAda,
          di_pp_ht_ada_digunakan: diPpHtAdaDigunakan,
          di_pp_ht_ada_digunakan_oleh: diPpHtAdaDigunakanOleh,
          di_nilai_stragtegis: diNilaiStragtegis,
          di_nilai_stragtegis_child: diNilaiStragtegisChild,
          di_pengamanan_fisik: diPengamananFisik,
          di_pengamanan_fisik_child: diPengamananFisikChild,
          di_pengamanan_fisik_note: diPengamananFisikNote,
          di_sengketa: diSengketa,
          di_aset_bersejarah: diAsetBersejarah,
        } = data
        if (!diMKobar || !diKdKel || !diMBertingkat) isShowInfo.value = true

        kolok.value = `${KOLOK}::${namaPdUkpdSiera}`
        kib.value = kibVal
        if (kibVal == 'A') title.value = 'KIB A - Fase Desktop'
        else if (kibVal == 'D') title.value = 'KIB D - Fase Desktop'
        kobar.value = kobar108
        nabar.value = nabar108
        kodeRegisterBarang.value = noreg108
        nilaiPerolehan.value = HARGA
          ? intThousand(HARGA.toString().replace('.', ','))
          : ''
        tahunPerolehan.value = TGLOLEH
        ukuran.value = UKURAN?.toString().replace('.', ',')
        jenisBeton.value = BETON
        alamat.value = ALAMAT
        rekonKode.value = rekonKodeVal
        rekonTahun.value = rekonTahunVal
        satuan.value = SATUAN

        kesesuaianKodeBarang.value = diMKobar || ''
        kibSeharusnya.value = diMKobarKib || kibVal
        namaSpesifikasiBarang.value = diNmSpesifikasiBarang || ''
        satuanSeharusnya.value = SATUAN

        let index
        let resKobar
        let resNoReg
        if (diMKobarA) {
          resKobar = await getKobar(kibSeharusnya.value)
          resKobar.rows.map(item => {
            if (item.kode == diMKobarA) {
              satuanSeharusnya.value = item.kodeSatuan
              namaBarangSeharusnya.value = item.nama
              kodeBarangSeharusnya.value = {
                text: `${item.kode} :: ${item.nama}`,
                value: diMKobarA,
              }
            }
            return {
              kodeSatuan: item.kodeSatuan,
            }
          })

          index = resKobar.rows.findIndex(item => item.kode == diMKobarA)
        }

        kesesuaianUkuran.value = diMUkuran || ''
        ukuranSeharusnya.value = diMUkuranA

        caraPerolehanPenerimaan.value = diCaraPerolehan
        isBertingkat.value = diMBertingkat || ''
        bertingkatSeharusnya.value = !diMBertingkatA || diMBertingkatA == '0'
          ? null
          : diMBertingkatA
        isLantaiDigunakan.value = diMLantaiTdk || ''
        jumlahSeluruhLantai.value = diMBertingkatA
          ? (parseInt(diMBertingkatA, 10) + 1).toString()
          : ''
        jumlahLantaiTidakDigunakan.value = diMLantaiTdkNot
        jumlahLantaiDigunakan.value = diMLantaiTdkUse
        kesesuaianBahan.value = diMBeton
        bahanSeharusnya.value = diMBetonA
        skPenggunaan.value = diMSkPenggunaan || ''
        nomorSkPenggunaan.value = diSkPenggunaanNo
        tahunSkPenggunaan.value = diSkPenggunaanTahun

        dataPdUkpd.value = await getPdUkpd()

        penggunaan.value = diPenggunaan
        if (penggunaanOpd) {
          if (penggunaanOpd.length > 0) {
            digunakanBersama.value.push('1')

            pdUkpd.value = []
            digunakanUntuk.value = []
            for (let i = 0; i < penggunaanOpd.length; i += 1) {
              const { di_penggunaan_opd, di_penggunaan_untuk } = penggunaanOpd[i]

              pdUkpd.value.push({
                value: { text: di_penggunaan_opd, value: di_penggunaan_opd },
              })
              digunakanUntuk.value.push({ value: di_penggunaan_untuk })
            }
          }
        }
        if (penggunaanPihakLain) {
          if (penggunaanPihakLain.length > 0) {
            digunakanBersama.value.push('0')

            pemanfaat.value = []
            for (let i = 0; i < penggunaanPihakLain.length; i += 1) {
              const {
                di_penggunaan_pemanfaat,
                di_penggunaan_pemanfaat_nama,
                di_penggunaan_pemanfaat_dasar,
                di_penggunaan_pemanfaat_dasar_type,
              } = penggunaanPihakLain[i]

              pemanfaat.value.push({
                value: di_penggunaan_pemanfaat,
                namaPemanfaat: di_penggunaan_pemanfaat_nama,
                dasarPenggunaan: di_penggunaan_pemanfaat_dasar,
                dasarPenggunaanTipe: di_penggunaan_pemanfaat_dasar_type,
              })
            }
          }
        }

        gedungBangunanTanahMilik.value = diGedungBangunanDiatasTanahMilik
        if (diGedungBangunanDiatasTanahMilik == 1) {
          isGedungBangunanTanahMilikTercatat.value = diGedungBangunanDiatasTanahMilikTercatat

          if (diGedungBangunanDiatasTanahMilikTercatat == 1) {
            index = dataPdUkpd.value.findIndex(
              item => item.value == diGedungBangunanDiatasTanahMilikOpd,
            )

            gedungBangunanTanahMilikPdUkpd.value = index >= 0 ? dataPdUkpd.value[index] : defaultKolok

            index = -1
            resKobar = await getKobar(
              'A',
              '',
              diGedungBangunanDiatasTanahMilikOpd,
            )
            dataGedungBangunanTanahMilikKobar.value = resKobar.rows.map(
              (item, i) => {
                if (item.kode == diGedungBangunanDiatasTanahMilikKobar) { index = i }
                return {
                  text: `${item.kode} :: ${item.nama}`,
                  value: item.kode,
                  nama: item.nama,
                }
              },
            )

            gedungBangunanTanahMilikKobar.value = index >= 0
              ? dataGedungBangunanTanahMilikKobar.value[index]
              : { text: '-- Pilih Salah Satu --', value: null }

            resNoReg = await getNoReg('A')
            dataGedungBangunanTanahMilikRegister.value = resNoReg.rows
            if (dataGedungBangunanTanahMilikRegister.value) {
              dataGedungBangunanTanahMilikRegister.value = dataGedungBangunanTanahMilikRegister.value.map((item, i) => {
                if (
                  item.noreg_108
                    == diGedungBangunanDiatasTanahMilikNoreg
                ) { index = i }
                return {
                  text: `${item.noreg_108} :: ${item.ALAMAT}`,
                  value: item.noreg_108,
                }
              })

              gedungBangunanTanahMilikRegister.value = index >= 0
                ? dataGedungBangunanTanahMilikRegister.value[index]
                : { text: '-- Pilih Salah Satu --', value: null }
            }
          } else { gedungBangunanTanahMilikKeterangan.value = diGedungBangunanDiatasTanahMilikSebut }
        } else if (
          diGedungBangunanDiatasTanahMilik == 2
          || diGedungBangunanDiatasTanahMilik == 3
          || diGedungBangunanDiatasTanahMilik == 4
        ) { gedungBangunanTanahMilikSebutkan.value = diGedungBangunanDiatasTanahMilikSebut }

        provinsi.value = diKdProp
        kabKota.value = diKdRayon
        kecamatan.value = diKdKec
        kelurahan.value = diKdKel
        jalan.value = diJalan || ''
        noAlamat.value = diNoJalan
        rt.value = diRt || ''
        rw.value = diRw || ''
        kodePos.value = diKodepos || ''
        isIndikasiGanda.value = diIndikasiGanda || ''
        indikasiGandaDengan.value = diIndikasiGandaDengan
        indikasiGandaSebutkan.value = diIndikasiGandaSebutkan
        indikasiGandaPdUkpd.value = diIndikasiGandaOpd
          ? { text: diIndikasiGandaOpd, value: diIndikasiGandaOpd }
          : defaultKolok
        indikasiGandaKobar.value = diIndikasiGandaKobar
          ? { text: diIndikasiGandaKobar, value: diIndikasiGandaKobar }
          : { text: '-- Pilih Salah Satu --', value: null }
        indikasiGandaRegister.value = diIndikasiGandaRegister
          ? {
            text: diIndikasiGandaRegister,
            value: diIndikasiGandaRegister,
          }
          : { text: '-- Pilih Salah Satu --', value: null }

        indikasiGabungan.value = diIndikasiGabungan
        if (diIndikasiGabungan) { indikasiGabunganKeterangan.value = diIndikasiGabunganKeterangan }

        isAtapBeton.value = diPpAtAda
        isAtapBetonIsDigunakan.value = diPpAtAdaDigunakan
        atapBetonDigunakan.value = diPpAtAdaDigunakanOleh
        isBasement.value = diPpBmAda
        isBasementIsDigunakan.value = diPpBmAdaDigunakan
        basementDigunakan.value = diPpBmAdaDigunakanOleh
        isHalamanUtama.value = diPpHtAda
        isHalamanUtamaIsDigunakan.value = diPpHtAdaDigunakan
        halamanUtamaDigunakan.value = diPpHtAdaDigunakanOleh
        nilaiStrategisBMD.value = diNilaiStragtegis
        memilikiNilaiStrategis.value = diNilaiStragtegisChild || []
        pengamananFisik.value = diPengamananFisik
        fisikDikuasai.value = diPengamananFisikChild
        fisikDikuasaiSebutkan.value = diPengamananFisikNote
        fisikTidakDikuasaiSebutkan.value = diPengamananFisikNote
        sengketaGedungBangunan.value = diSengketa
        ketAsetBersejarah.value = diAsetBersejarah

        if (status == 6) statusPersetujuan.value = '0'
        else if (status == 7) statusPersetujuan.value = '1'
        else statusPersetujuan.value = null
        catatan.value = diValidasiSensusNote
      }
      isShowUbah.value = false
    }

    getData()

    return {
      title,
      kolok,
      kib,
      kobar,
      nabar,
      satuan,
      kodeRegisterBarang,
      nilaiPerolehan,
      tahunPerolehan,
      ukuran,
      jenisBeton,
      alamat,
      rekonKode,
      rekonTahun,
      kesesuaianKodeBarang,
      satuanSeharusnya,
      kibSeharusnya,
      namaBarangSeharusnya,
      kodeBarangSeharusnya,
      namaSpesifikasiBarang,
      kesesuaianUkuran,
      ukuranSeharusnya,
      caraPerolehanPenerimaan,
      isBertingkat,
      bertingkatSeharusnya,
      jumlahSeluruhLantai,
      isLantaiDigunakan,
      jumlahLantaiTidakDigunakan,
      jumlahLantaiDigunakan,
      kesesuaianBahan,
      bahanSeharusnya,
      skPenggunaan,
      nomorSkPenggunaan,
      tahunSkPenggunaan,
      penggunaan,
      digunakanBersama,
      digunakanUntuk,
      pdUkpd,
      pemanfaat,
      gedungBangunanTanahMilik,
      isGedungBangunanTanahMilikTercatat,
      gedungBangunanTanahMilikPdUkpd,
      gedungBangunanTanahMilikKobar,
      gedungBangunanTanahMilikRegister,
      gedungBangunanTanahMilikKeterangan,
      gedungBangunanTanahMilikSebutkan,
      provinsi,
      kabKota,
      kecamatan,
      kelurahan,
      jalan,
      noAlamat,
      rt,
      rw,
      kodePos,
      isIndikasiGanda,
      indikasiGandaDengan,
      indikasiGandaSebutkan,
      indikasiGandaPdUkpd,
      indikasiGandaKobar,
      indikasiGandaRegister,
      indikasiGabungan,
      indikasiGabunganKeterangan,
      isAtapBeton,
      isAtapBetonIsDigunakan,
      atapBetonDigunakan,
      isBasement,
      isBasementIsDigunakan,
      basementDigunakan,
      isHalamanUtama,
      isHalamanUtamaIsDigunakan,
      halamanUtamaDigunakan,
      nilaiStrategisBMD,
      memilikiNilaiStrategis,
      pengamananFisik,
      fisikDikuasai,
      fisikDikuasaiSebutkan,
      fisikTidakDikuasaiSebutkan,
      sengketaGedungBangunan,
      ketAsetBersejarah,
      dataGedungBangunanTanahMilikKobar,
      dataGedungBangunanTanahMilikRegister,
      statusPersetujuan,
      catatan,
      isShowUbah,
      isShowInfo,
    }
  },
  components: {
    FormC,
    FormA,
  },
  props: {
    id: { type: String, default: '' },
  },
}
</script>
